import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LocusRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class LocusRobotics_get_bot_configurationsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: {  }): Promise<{ list?: { Lookup?: string, weight_capacity?: number, height?: number, width?: number, length?: number, warehouse?: string, type?: string, bin_capacity?: number, dimension_uom?: string, volume_capacity?: number, weight_uom?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }

}

